import { ITraTienSinhVienDotFilterRequest } from "../../../model/request/bao-cao/ITraTienSinhVienRequest";
import {
  ITraTienSinhVienChiTiet,
  ITraTienSinhVienDot,
  ITraTienSinhVienLog,
} from "../../../model/respone/bao-cao/ITraTienSinhVien";
import { ITraTienSinhVienActionTypes } from "../../action-types/bao-cao/ITraTienSinhVienActions";
import { ITraTienSinhVienReducer } from "../../reducer-model/bao-cao/ITraTienSinhVienReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: ITraTienSinhVienReducer = {
  status: eReducerStatusBase.is_not_initialization,
  // KHÔNG để "đã xong" lúc khởi tạo: màn hình canh theo trạng thái này để biết đợt có dòng hay
  // không. Để "đã xong" khi còn CHƯA nạp gì thì nó kết luận đợt rỗng rồi đứng lại ở bước 1,
  // dữ liệu về sau cũng không được hiện ra nữa (lỗi 29/10/2026).
  statusChiTiet: eReducerStatusBase.is_not_initialization,
  statusExport: eReducerStatusBase.is_completed,
  statusLog: eReducerStatusBase.is_completed,
  // Mặc định xem MỌI đợt: đợt trả tiền thường trải qua vài kỳ, lọc sẵn theo kỳ hiện tại
  // là người dùng mở màn lên thấy trống rỗng và tưởng mất dữ liệu.
  request: { hoc_ky: 0, nam_hoc: "" },
  dots: [],
  idDot: 0,
  chiTiets: [],
  logs: [],
  loiChiTiet: "",
  luuThanhCong: 0,
};

export const traTienSinhVienReducer = (
  state: ITraTienSinhVienReducer = iniState,
  action: ITraTienSinhVienActionTypes,
): ITraTienSinhVienReducer => {
  switch (action.type) {
    case "TRA_TIEN_SINH_VIEN_CHANGE_REQUEST":
      return {
        ...state,
        request: {
          ...state.request,
          ...(action.payload as Partial<ITraTienSinhVienDotFilterRequest>),
        },
        status: eReducerStatusBase.is_need_reload,
      };

    // ===== Đợt =====
    case "TRA_TIEN_SINH_VIEN_LOAD_DOT_START":
      return { ...state, status: eReducerStatusBase.is_loading };
    case "TRA_TIEN_SINH_VIEN_LOAD_DOT_SUCCESS": {
      const dots = action.payload as ITraTienSinhVienDot[];
      // Đợt đang chọn vừa bị xoá thì bỏ chọn, không để cột phải treo dữ liệu cũ.
      const idDot = dots.some((d) => d.id === state.idDot) ? state.idDot : 0;
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        dots,
        idDot,
        chiTiets: idDot ? state.chiTiets : [],
      };
    }
    case "TRA_TIEN_SINH_VIEN_LOAD_DOT_ERROR":
      return { ...state, status: eReducerStatusBase.is_completed };

    case "TRA_TIEN_SINH_VIEN_CHON_DOT":
      // Đổi đợt là lập tức "đang nạp": danh sách dòng của đợt cũ đã bỏ, của đợt mới thì chưa về.
      return {
        ...state,
        idDot: action.payload as number,
        chiTiets: [],
        logs: [],
        statusChiTiet: eReducerStatusBase.is_loading,
        loiChiTiet: "",
      };

    case "TRA_TIEN_SINH_VIEN_SAVE_DOT_START":
    case "TRA_TIEN_SINH_VIEN_DELETE_DOT_START":
    case "TRA_TIEN_SINH_VIEN_KHOA_START":
      return { ...state, status: eReducerStatusBase.is_loading };
    case "TRA_TIEN_SINH_VIEN_SAVE_DOT_SUCCESS":
      // Đợt vừa tạo được chọn ngay để người dùng nhập Excel luôn.
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        idDot: (action.payload as number) || state.idDot,
      };
    case "TRA_TIEN_SINH_VIEN_DELETE_DOT_SUCCESS":
    case "TRA_TIEN_SINH_VIEN_KHOA_SUCCESS":
      return { ...state, status: eReducerStatusBase.is_need_reload };
    case "TRA_TIEN_SINH_VIEN_SAVE_DOT_ERROR":
    case "TRA_TIEN_SINH_VIEN_DELETE_DOT_ERROR":
    case "TRA_TIEN_SINH_VIEN_KHOA_ERROR":
      return { ...state, status: eReducerStatusBase.is_completed };

    case "TRA_TIEN_SINH_VIEN_LUU_THIET_LAP_IN_START":
    case "TRA_TIEN_SINH_VIEN_LUU_THIET_LAP_IN_SUCCESS":
    case "TRA_TIEN_SINH_VIEN_LUU_THIET_LAP_IN_ERROR":
      // Lưu ngầm khi người dùng chỉnh ở màn Thiết lập in — không đụng tới trạng thái màn hình.
      return state;

    // ===== Danh sách dòng =====
    case "TRA_TIEN_SINH_VIEN_LOAD_CHI_TIET_START":
      return {
        ...state,
        statusChiTiet: eReducerStatusBase.is_loading,
        loiChiTiet: "",
      };
    case "TRA_TIEN_SINH_VIEN_LOAD_CHI_TIET_SUCCESS":
      return {
        ...state,
        statusChiTiet: eReducerStatusBase.is_completed,
        chiTiets: (action.payload as ITraTienSinhVienChiTiet[]) ?? [],
        loiChiTiet: "",
      };
    case "TRA_TIEN_SINH_VIEN_LOAD_CHI_TIET_ERROR":
      // Giữ nguyên chiTiets cũ: đọc hỏng không có nghĩa là dữ liệu đã lưu biến mất.
      return {
        ...state,
        statusChiTiet: eReducerStatusBase.is_completed,
        loiChiTiet: (action.payload as string) || "Không đọc được danh sách dòng",
      };

    case "TRA_TIEN_SINH_VIEN_SAVE_CHI_TIET_START":
      return { ...state, statusChiTiet: eReducerStatusBase.is_loading };
    case "TRA_TIEN_SINH_VIEN_SAVE_CHI_TIET_SUCCESS":
      return {
        ...state,
        statusChiTiet: eReducerStatusBase.is_completed,
        luuThanhCong: state.luuThanhCong + 1,
        // Nạp lại cả cột trái: số dòng và tổng tiền của đợt vừa đổi.
        status: eReducerStatusBase.is_need_reload,
      };
    case "TRA_TIEN_SINH_VIEN_SAVE_CHI_TIET_ERROR":
      return { ...state, statusChiTiet: eReducerStatusBase.is_completed };

    // ===== Lịch sử =====
    case "TRA_TIEN_SINH_VIEN_LOAD_LOG_START":
      return { ...state, statusLog: eReducerStatusBase.is_loading };
    case "TRA_TIEN_SINH_VIEN_LOAD_LOG_SUCCESS":
      return {
        ...state,
        statusLog: eReducerStatusBase.is_completed,
        logs: action.payload as ITraTienSinhVienLog[],
      };
    case "TRA_TIEN_SINH_VIEN_LOAD_LOG_ERROR":
      return { ...state, statusLog: eReducerStatusBase.is_completed };

    // ===== Xuất / in =====
    case "TRA_TIEN_SINH_VIEN_EXPORT_EXCEL_START":
    case "TRA_TIEN_SINH_VIEN_XEM_TRUOC_START":
      return { ...state, statusExport: eReducerStatusBase.is_loading };
    case "TRA_TIEN_SINH_VIEN_EXPORT_EXCEL_SUCCESS":
    case "TRA_TIEN_SINH_VIEN_EXPORT_EXCEL_ERROR":
    case "TRA_TIEN_SINH_VIEN_XEM_TRUOC_ERROR":
      return { ...state, statusExport: eReducerStatusBase.is_completed };
    case "TRA_TIEN_SINH_VIEN_XEM_TRUOC_SUCCESS":
      return {
        ...state,
        statusExport: eReducerStatusBase.is_completed,
        printHtml: action.payload as string,
      };
    case "TRA_TIEN_SINH_VIEN_DONG_XEM_TRUOC":
      return { ...state, printHtml: undefined };

    default:
      return state;
  }
};
